<template lang="pug">
    header
        .container
            nav(:class="{show:menuIsOpen}")
                router-link(to="/" active-class="active" exact  @click.native="toggleMenu") {{$t('hf.calendarCelebration')}}
                router-link(to="/allevents" active-class="active"  @click.native="toggleMenu") {{$t('hf.eventsTypes')}}
                a(href="https://polus.atom.online/" target="_blank" v-if="$i18n.locale === 'ru'") {{$t('hf.knowledges')}}
                //- a(href="https://atom75.ru/contest") Конкурс Ледокол
                a(:href="$i18n.locale==='ru' ? 'https://atom75.ru/' : 'https://atom75.com/'") {{$t('hf.history')}}
                a.dropdown(v-if="$i18n.locale === 'ru'") {{$t('hf.more')}}
                    .dropdown_list
                        router-link(to="/forjournalists" active-class="active" exact @click.native="toggleMenu") {{$t('hf.forMedia')}}
                .socials
                    a.fb(href="https://www.facebook.com/rosatom.ru" target="_blank")
                        img.white(:src="require('@/assets/img/socials/fb_white.png')")
                        img.black(:src="require('@/assets/img/socials/fb_black.png')")
                    a(href="https://www.instagram.com/rosatom_ru/" target="_blank")
                        img.white(:src="require('@/assets/img/socials/inst_white.png')")
                        img.black(:src="require('@/assets/img/socials/inst_black.png')")
                    a(href="https://vk.com/rosatomru" target="_blank")
                        img.white(:src="require('@/assets/img/socials/vk_white.png')")
                        img.black(:src="require('@/assets/img/socials/vk_black.png')")
                    a(href="https://twitter.com/rosatom/" target="_blank")
                        img.white(:src="require('@/assets/img/socials/tw_white.png')")
                        img.black(:src="require('@/assets/img/socials/tw_black.png')")
                    a(href="https://www.youtube.com/user/MirnyAtom" target="_blank")
                        img.white(:src="require('@/assets/img/socials/yt_white.png')")
                        img.black(:src="require('@/assets/img/socials/yt_black.png')")
                .lang
                    a(href="https://calendar.atom75.ru/" v-html="'РУС&nbsp;/&nbsp;'" :class="{red: $i18n.locale === 'ru'}")
                    a(href="https://calendar.atom75.com/" v-html="'ENG'" :class="{red: $i18n.locale === 'en'}")
            .burger(@click="toggleMenu" :class="{active:menuIsOpen, hide: hideBurger}")
                svg.ham.hamRotate.ham1.active(preserveAspectRatio="none" viewbox='0 0 100 100' width='80' onclick="this.classList.toggle('active')")
                    path.line.line_top(d='m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40')
                    path.line.line_middle(d='m 30,50 h 40')
                    path.line.line_bottom(d='m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656')

</template>

<script>
    export default {
        name: "Header",
        data: ()=>({
            menuIsOpen: false,
        }),
        computed:{
            hideBurger(){return this.$store.state.hideBurger},
            isMobileOrTablet(){return this.$store.state.isMobileOrTablet},
        },
        methods:{
            toggleMenu(){
                if (!this.isMobileOrTablet) return;
                if (this.menuIsOpen){
                    this.menuIsOpen = false
                    this.$store.commit('pageDelHidden');
                }else{
                    this.menuIsOpen = true
                    this.$store.commit('pageHidden');
                }
            },
            setLocale(locale){
                this.$i18n.locale = locale;
            }
        },
    }
</script>

<style scoped lang="scss">

    header {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        padding: 0 17px;
        padding-top: 3.5vh;
        z-index: 100;
        nav {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 1.25rem;
            text-transform: uppercase;
            color: #fff;

            & > a {
                position: relative;
                color: inherit;
                transition: color .3s;
                &.active{
                    color: #fff;
                    transition: 0s;
                    &:before{
                        content: '';
                        display: block;
                        position: absolute;
                        top: -0.2rem;
                        left: -1.7rem;
                        right: -1.7rem;
                        bottom: -0.15rem;
                        z-index: -1;
                        transform: skewX(-17deg);
                        background: red;
                    }
                }
                &:not(:first-child){
                    margin-left: 2.3vw;
                }
                &:not(.active):hover{
                    color: $red;
                }
            }
            .dropdown{
                position: relative;
                cursor: pointer;
                .dropdown_list{
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    flex-direction: column;
                    width: 15.8rem;
                    padding: 1.5rem 2rem 0.3rem;
                    background: #fff;
                    box-shadow: 0 0 1rem rgba(#000, 0.2);
                    top: -99999px;
                    opacity: 0;
                    transition: top 0s .4s, opacity .3s .1s;
                    cursor: initial;
                    &:before{
                        content: '';
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%, -50%) rotate(45deg) skew(8deg, 8deg);
                        width: 0.8rem;
                        height: 0.8rem;
                        background: #fff;
                    }
                    a{
                        margin-bottom: 1.1rem;
                        color: #000;
                        transition: color .3s;
                        cursor: pointer;
                        &:hover{
                            color: $red;
                        }
                    }
                }
                &:hover{
                    .dropdown_list{
                        top: calc(100% + 0.8rem);
                        opacity: 1;
                        transition: transform 0s, opacity .3s;
                    }
                }
            }
            .socials {
                position: relative;
                display: flex;
                padding-left: 1.5rem;
                &:before{
                    content: '';
                    position: absolute;
                    top: 35%;
                    left: 0;
                    transform: translateY(-50%);
                    width: 1px;
                    height: 3rem;
                    background: #fff;
                    display: none;
                }
                a {
                    position: relative;
                    display: block;
                    margin: 0 0.6rem;
                    cursor: pointer;
                    img.black{
                        position: absolute;
                        top: 0;
                        left: 0;
                        opacity: 0;
                    }
                    &.fb{
                        width: 0.6rem;
                        img{
                            width: 100%;
                        }
                    }
                }
            }
            .lang{
                margin-left: 2rem;
                color: #fff;
                a{
                    color: inherit;
                }
                .red{
                    color: $red;
                }
            }
        }

        .burger{
            position: relative;
            display: none;
            transform-origin: 100% 0;
            svg{
                height: 100px;
                width: 100px;
                transition: transform 400ms;
                user-select: none;
            }
            path.line{
                stroke: #fff;
            }
            .line{
                fill: none;
                transition: stroke-dasharray 400ms, stroke-dashoffset 400ms, stroke .3s .3s;
                stroke: #fff;
                stroke-width: 5.5;
                stroke-linecap: round;
                &.line_top{
                    stroke-dasharray: 40 139;
                }
                &.line_middle{
                    stroke-dasharray: 40 180;
                }
                &.line_bottom{
                    stroke-dasharray: 40 139;
                }
            }
            &.active{
                svg{
                    transform: rotate(45deg);
                    path{
                        stroke: #fff;
                    }
                }
                .line.line_top{
                    stroke-dashoffset: -98px;
                }
                .line.line_bottom{
                    stroke-dashoffset: -138px;
                }
            }
            &.hide{
                opacity: 0;
                pointer-events: none;
            }
            @include razr530{
                transform: scale(0.8);
            }
            @include razr375{
                transform: scale(0.7);
            }
        }


        &.black{
            nav, .lang{
                color: #000;
            }
            .socials a img{
                &.white{
                    opacity: 0;
                }
                &.black{
                    opacity: 1;
                }
            }
            .burger path.line{
                stroke: #000;
            }
        }
        @include mobile_or_P{
            pointer-events: none;
            padding: 0;
            &.black{
                nav{
                    background: #fff;
                    a{
                        color: #000;
                        &.active{
                            color: #fff;
                        }
                    }
                    .socials:before{
                        background: #000;
                    }
                }
            }
            .container{
                display: flex;
                justify-content: flex-end;
                padding: 0;
            }
            nav{
                position: absolute;
                top: 0;
                left: 0;
                height: 100vh;
                width: 100vw;
                margin: 0;
                padding: 10vmin 1.4rem 10vmin;
                background: url(../../assets/img/menu_bg-mobile.jpg) no-repeat center center / 100% 100%;
                flex-direction: column;
                justify-content: center;
                font-family: Pobeda;
                font-weight: bold;
                transform: translate3d(-100%,0,0);
                opacity: 0;
                transition: .5s;
                pointer-events: all;
                overflow: auto;
                &.show{
                    transform: translate3d(0,0,0);
                    opacity: 1;
                }
                a{
                    margin: 0 0 1.1rem;
                    color: #fff;
                    font-size: 7vmin;
                    &:not(:first-child){
                        margin: 0 0 1.1rem;
                    }
                    &.active:before{
                        top: -0.4rem;
                        left: -3rem;
                        right: -3rem;
                        bottom: -0.3rem;
                    }
                }
                .dropdown{
                    .dropdown_list{
                        width: 80vmin;
                        z-index: 1;
                        a{
                            color: #000;
                        }
                    }
                }
                .socials{
                    justify-content: center;
                    width: 100%;
                    margin: 0.75rem 0 1.1rem;
                    padding: 1.4rem 0 0;
                  align-items: center;
                    &:before{
                        display: block;
                        top: 0;
                        width: 100%;
                        height: 1px;
                    }
                    a{
                      display: flex;
                      align-items: center;
                        margin: 0 3vmin;
                        img.white{
                            opacity: 1;
                        }
                        img.black{
                            opacity: 0;
                        }
                      &.fb {
                        img {
                          height: 20px;
                          width: auto;
                        }
                      }
                    }
                }
                .lang{
                    margin-left: 0;
                }
            }
            .burger{
                display: block;
                pointer-events: all;
            }
        }
    }
</style>
